import {
  poppins,
  neueHaas,
  suissBook,
  suissCond,
  spaceGrotesk,
  esKlarheitKurrent,
  esKlarheitGrotesk,
} from '@/lib/fonts/fonts';

export const FONT_VARIABLE_CLASSES = [
  poppins.variable,
  neueHaas.variable,
  suissBook.variable,
  suissCond.variable,
  spaceGrotesk.variable,
  esKlarheitKurrent.variable,
  esKlarheitGrotesk.variable,
];

export function getFontClasses(siteTheme: string): string {
  const classes = [poppins.variable];

  const extraFonts: Record<string, string[]> = {
    'bayerische-staatsoper': [neueHaas.variable],
    'julia-fischer': [suissBook.variable, suissCond.variable],
    'zurich-operahaus': [
      esKlarheitKurrent.variable,
      esKlarheitGrotesk.variable,
      spaceGrotesk.variable,
    ],
  };

  if (extraFonts[siteTheme]) {
    classes.push(...extraFonts[siteTheme]);
  }

  return classes.join(' ');
}
